// extracted by css-extract-rspack-plugin
export default {"logo":"zx4IR8","dot":"y6S1Rk","dots":"QkGYdX","blobs":"RXH5rs","filter":"XgFtwg"};